
import { getGPUTier } from 'detect-gpu'

import Sniffer from 'snifferjs'
import { getQuery } from 'utils/common'
import { getLogger } from 'utils/logger'
const info = getLogger('Performance', '#46466E', true)

import Tests from 'helpers/Tests'

// Detect the performance of the device
class Performance {
  constructor () {

    const GPUTier = getGPUTier({
      // glContext?: gl, // Optionally pass in a WebGL context to avoid creating a temporary one internally
      // mobileBenchmarkPercentages: [0, 50, 30, 20], // (Default) [TIER_0, TIER_1, TIER_2, TIER_3]
      // desktopBenchmarkPercentages: [0, 50, 30, 20], // (Default) [TIER_0, TIER_1, TIER_2, TIER_3]
      // forceRendererString?: 'Apple A11 GPU', // (Development) Force a certain renderer string
      // forceMobile?: true, // (Development) Force the use of mobile benchmarking scores
    })

    this.GPUTier = GPUTier;

    window.perf = this;

    this.rawTier = GPUTier.tier
    this.type = GPUTier.type


    info(`tier: ${GPUTier.tier} | type: ${GPUTier.type}`)
    this.tier = parseInt(GPUTier.tier.match(/\d+/), 10)


    if (this.tier > 0 && this.type.indexOf('iris') > 0 ) {
      let splitted = this.type.split(' ')
      let number = splitted[splitted.length-1];
      number = parseInt(number, 10);
      if(!isNaN(number) && number < 650) {
        this.tier = 0;
        this.tierForced = true;
      } 
    }

    if (this.tier === 0 && this.type.indexOf('iris') > 0 && this.type.indexOf('engine') > 0) {
      this.oldMBP = true;
    }

    if (this.type.indexOf('hd graphics') > 0) {
      this.tier = 0;
      this.tierForced = true;
      this.oldMBP = true;
    }

    if (this.type.indexOf('intel') > 0) {
      this.tier = Math.min(this.tier, 1);
      this.tierForced = true;
    }


    if (getQuery('perf')) {
      setTimeout(()=>{
        this._debug()
      }, 5000)
    }

    document.body.classList.add('is-gpu-' + this.tier)
  }

  _debug() {

    var sniffer = Sniffer(window.navigator.userAgent)
    const perf = document.createElement('div')
    document.body.appendChild(perf)
    perf.style.position = 'fixed'
    perf.style.top = '100px'
    perf.style.left = '100x'
    perf.style.width = '100%'
    perf.style.height = '100%'
    perf.style.background = '#46466E'
    perf.style.color = 'white'
    perf.style.padding = '50px'
    perf.style.fontSize = '1vw'
    perf.style.boxSizing = 'border-box'

    perf.innerHTML = `
    <p><b>TIME:</b> ${Date.now()} - ${new Date().toString()}</p>
    ${this.oldMBP ? '<p><b>OLD MBP:</b> VERY OLD</p>' : ''}
    <p><b>GPU RAW_TIER:</b> ${this.GPUTier.tier}</p>
    <p><b>GPU TIER:</b> ${this.tier}</p>
    <p><b>GPU TYPE:</b> ${this.GPUTier.type}</p>
    <p><b>WINDOW:</b> ${window.innerWidth}/${window.innerHeight}</p>
    <p><b>SCREEN SIZE:</b> ${window.screen.width}/${window.screen.height}</p>
    <p><b>SCREEN AVAILABLE SIZE:</b> ${window.screen.availWidth}/${window.screen.availHeight}</p>
    <p><b>PIXEL RATIO:</b> ${window.devicePixelRatio}</p>
    <p><b>SNIFFER:</b> ${JSON.stringify(sniffer)}</p>
    <p><b>USE FX VIDEO:</b> ${Tests.useFxVideo}</p>
    <p><b>USE FLUID:</b> ${Tests.useFluid}</p>
    <p><b>USE WEBGL:</b> ${Tests.useWebGL}</p>
    <p><b>USE SMOOTH SCROLL:</b> ${Tests.useSmoothScroll}</p>
    <p><b>GET DPR:</b> ${Tests.DPR}</p>
    `
    debugger
  }
}

export default new Performance()
